// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__E-WP5","disease":"style_disease__u9jSd"};